import React from 'react';
import Card from '../../../components/Card';
import SemesterLayout from '../../../components/SemesterLayout';

const Sem2 = ({ branch = "AIDS" }) => {
  const notes = [
    { title: 'Applied Physics-II', link: `/notes/${branch.toLowerCase()}/AppliedPhysicsII` },
    { title: 'Applied Mathematics-II', link: `/notes/${branch.toLowerCase()}/AppliedMathII` },
    { title: 'Applied Chemistry', link: `/notes/${branch.toLowerCase()}/AppliedChemistry` },
    { title: 'Communication Skills', link: `/notes/${branch.toLowerCase()}/CommunicationSkills` },
    { title: 'Engineering Graphics', link: `/notes/${branch.toLowerCase()}/Engineering Graphics` },
    { title: 'Engineering Mechanics', link: `/notes/${branch.toLowerCase()}/Engineering_Mechanics` },
    { title: 'Electrical Science', link: `/notes/${branch.toLowerCase()}/Electrical_Science` },
    { title: 'Enviromental Science', link: `/notes/${branch.toLowerCase()}/Enviromental_Studies` },
    { title: 'Human Values and Ethics', link: `/notes/${branch.toLowerCase()}/Human values and Ethics` },
    { title: 'Indian Constitution', link: `/notes/${branch.toLowerCase()}/Indian_Constitution` },
    { title: 'Manufacturing Process', link: `/notes/${branch.toLowerCase()}/Manufacturing_Process` },
    { title: 'Programming in C', link: `/notes/${branch.toLowerCase()}/Programming_In_C` },
    { title: 'Workshop', link: `/notes/${branch.toLowerCase()}/Workshop` }


  ];
  return (
    <SemesterLayout
      branch={branch}
      semester="2nd Semester"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {notes.map((note, index) => (
          <Card key={index} title={note.title} link={note.link} />
        ))}
      </div>
    </SemesterLayout>
  );
};

export default Sem2;
